import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Button from '../../ui/Button'
import { sendAnalyticsEventToNative } from '../../utils/analytics'

class RezultForms extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lastScrollPosition: 0,
      showButton: true,
    }
  }

  componentDidMount(){
    sendAnalyticsEventToNative('ecoCreditCardOrderResult')
  }

  render() {
    const { rezultMessage, showButton } = this.props
    return (
      <form className="rezult-form" onSubmit={() => window.location.assign('#q=success')} >
        <div className="scroll-container">
          <div className="rezult-form-container">
            <div className="info-container" dangerouslySetInnerHTML={{ __html: rezultMessage }}>
            </div>
            <div className='button-container-footer'>
              {showButton && <Button
                type='button'
                title='Добре'
                color={'success'}
                onClick={() => window.location.assign('#q=success')}
              />}
            </div>
          </div>
        </div>
      </form>
    )
  }
}

RezultForms.propTypes = {
  rezultMessage: PropTypes.string.isRequired,
}

const mapStateToPropa = state => ({
  state: state,
  rezultMessage: state.stateForm.messageRezult,
  showButton: state.stateForm.showButtonResult
})

export default connect(mapStateToPropa)(RezultForms)